import { createMutableAction } from '@bimser/core';
import { CLOSE_DIGITALSIGNATURE } from './actionTypes';

export const onCloseDigitalSignatureAction = (id: string, result: boolean) =>
	createMutableAction(CLOSE_DIGITALSIGNATURE, { id, result });
